import {getAuth} from "firebase/auth";

export const authGuard = (to, from, next) => {
    const authService = getAuth();
    authService.onAuthStateChanged((user) =>{
        // If the user is authenticated, continue with the route
        if (user != null) {
            if (!user.emailVerified) {
                return next("/auth/verify-email")
            }
            return next();
        }

        // Otherwise, log in
        //authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
        next(`/auth/login`)
    })()
};
